<template>
  <div :key="reRenderKey" class="view" v-if="theme" :style="minHeight">
    <page-intro 
      :sub-title="'['+theme.abbreviation +'] - ' + theme.title" 
      :view="'theme'" 
      v-on:changeview="$emit('changeview',$event)"
    ></page-intro>

    <div class="themeIntro">
      <div v-if="!theme.custom">
        <p v-html="chapo_g"></p>
        <!--
        <a v-if="theme.detail" class="detail-btn" @click="toggleDetails()">
          <chevron-right-icon title="" :class="{rotate: showDetail }" />{{ $t('views.themeView.detailBtn') }}
        </a>
        <p v-html="detail_g" id="themeDetails" style="display:none;"></p>
        -->
      </div>
      <div v-if="theme.custom" class="customThemeActions">
        <b-button
          class="link-btn"
          variant="link"
          @click="showAddElementPopin('RENAME-THEME')"
        >
          <lead-pencil-icon title="" />{{$t('views.themeView.renameBtn')}}
        </b-button>
        <b-button
          class="link-btn"
          variant="link"
          @click="showDeletePopin()"
        >
          <inrs-delete-icon title="" />{{$t('views.themeView.deleteBtn')}}
        </b-button>
      </div>

      <b-form-checkbox 
        class="myswitch"
        v-model="edit"
        @change="edit=!edit"
        name="check-button"
        switch
        size="lg"
      >{{$t('views.themeView.editSwitch')}}</b-form-checkbox>
      <div class="editorial editExplanations" v-if="$t('views.themeView.editExplanations')" v-html="$t('views.themeView.editExplanations')"></div>
    </div>

    <floating-bar></floating-bar>

    <theme :theme="theme" :edit="edit" v-on:addSubTheme="showAddElementPopin('NEW-SUBTHEME')"></theme>

    <div class="btn-container">
      <button
        class="refonte_btn-primary saveBtn"
        @click="goToThemesList()"
      >
        <img src="icons/themes.png" />{{ $t('views.themeView.goToThemesListBtn') }}
      </button>

      <button
        v-if="synthesisAccessible"
        class="refonte_btn-primary synthesisBtn"
        @click="goToSynthesisBtn()"
      >
        <img src="icons/synthese.png" />{{ $t('views.themeView.goToSynthesisBtn') }}
      </button>
    </div>    

  </div>
</template>

<script>
import PageIntro from "../components/PageIntro";
import FloatingBar from "../components/theme/FloatingBar";
import Theme from "../components/theme/Theme";
import LeadPencilIcon from 'vue-material-design-icons/LeadPencil.vue';
import InrsDeleteIcon from '../icons/InrsDelete.vue';
//import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue';

export default {
  name: "ThemeView",
  components: {
    PageIntro,
    FloatingBar,
    Theme,
    LeadPencilIcon,
    //ChevronRightIcon,
    InrsDeleteIcon
  },
  props: {
    theme: Object,
    minHeight: String
  },
  watch: {
    theme: function() {
      // On active le mode édition automatiquement lorsqu'aucun sous-thème n'existe encore.
    this.edit = this.theme && (!this.theme.subThemes || this.theme.subThemes.length==0);

      // Regénérer le composant quand l'objet thème change
      this.reRenderKey += 1;
    }
  },
  mounted: function() {
    // On active le mode édition automatiquement lorsqu'aucun sous-thème n'existe encore.
    this.edit = this.theme && (!this.theme.subThemes || this.theme.subThemes.length==0);

    initTooltips(".themeIntro"); //eslint-disable-line no-undef
  },  
  updated: function() {
    initTooltips(".themeIntro"); //eslint-disable-line no-undef
  },  
  /*created() {
    document.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
  },*/
  data: function() {
    return {
      reRenderKey: 0,
      floatingBarFixed: false, // detecter que la barre flotante est passée en position fixed
      showDetail: false, // afficher ou non la description détaillée du thème
      edit: false
      //  selectedNav: [true, false, false, false]
    };
  },
  computed: {
    chapo_g: function() {
      return JsonDataModule.getValueWithGlossary(this.theme, 'chapo'); //eslint-disable-line no-undef
    },
    /*
    detail_g: function() {
      return JsonDataModule.getValueWithGlossary(this.theme, 'detail'); //eslint-disable-line no-undef
    },
    */
    themes: function() {
      return this.$store.state.gpsstModule.gpsst.themes;
    },
    /**
     * Indique si l'écran de synthèse est accessible (au moins un thème complet ou incomplet).
     */
    synthesisAccessible: function() {
      // on regarde si l'accès à la synthèse est possible
      if (this.$store.state.appState.compagnyCompleted) {
        for (let i = 0; i < this.themes.length; i++) {
          if (
            this.themes[i].status == "complete" ||
            this.themes[i].status == "incomplete"
          ) {
            return true;
          }
        }
      }
      return false;
    }     
  },
  methods: {
    toggleDetails: function() {
      this.showDetail = !this.showDetail;
      $('#themeDetails').slideToggle(); //eslint-disable-line no-undef
    },
    showDeletePopin: function() {
      this.$store.commit("SET_POPIN", {
          themeAbbr: this.theme.abbreviation,
          type: "DEL-THEME"
        });
       this.$bvModal.show("deleteElement");
    },
    showAddElementPopin: function(type) {
      if (type == "NEW-SUBTHEME") {
        this.$store.commit("SET_POPIN", {
          type: type,
          themeAbbr: this.theme.abbreviation
        });
      }
      if (type == "RENAME-THEME") {
        this.$store.commit("SET_POPIN", {
          type: type,
          themeAbbr: this.theme.abbreviation,
          themeRef: this.theme.ref,
          title: this.theme.title,
          abbr: this.theme.abbreviation
        });
      }

      this.$bvModal.show("addThemeElement");
    },
    /**
     * Affiche l'écran "Liste des thèmes".
     */
    goToThemesList : function() {
      this.$emit("changeview", { view: "themesList" });
    },
    /**
     * Affiche l'écran "Synthèse".
     */
    goToSynthesisBtn: function() {
      this.$emit("changeview", { view: "synthesis" });
    }
  }
};
</script>

<style lang="sass" scoped>
@import "../sass/_variables.sass"

//.detail-btn
//  color: $classic-link !important
//  font-weight: bold
//  display: flex
//  align-items: center
//  cursor: pointer
//
//  .material-design-icon
//    margin-left: -0.5em
//    &.rotate
//      transform: rotate(90deg)

.link-btn
  display: inline-flex
  align-items: center
  gap: 6px
  color: $darkgray-3
  padding-left: 0
  font-family: 'brother-1816', pt_sans, Arial, "Helvetica Neue", Helvetica, sans-serif
  font-size: 1.38rem
  font-weight: bold
  &:hover, &:focus
    color: $darkgray-3

.myswitch
  margin-top: 1em
  margin-bottom: 1em
  font-weight: bold
  user-select: none
  // suite dans public/style/style.css

.editExplanations
  margin: -1em 0 1em 2.8em
  color: $darkgray-3 

.customThemeActions
  button
    margin-right: 1em
  
.btn-container
  display: flex
  justify-content: center
  flex-wrap: wrap
  gap: 20px
  margin: 2em 0 -1em 0

  .defaultButton
    font-weight: bold
    font-size:1.3em
    height: 50px
    margin:0 1em 1em 1em

</style>


